import React, { useState, useEffect } from "react";
import OrdersTable from "./OrdersTable";
import { orderService, Order } from "../../api/orderService";

const OrdersPage: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const data = await orderService.getAllOrders();
      setOrders(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching orders:", err);
      setError(err instanceof Error ? err.message : "Failed to fetch orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleStatusUpdate = async (
    orderId: string,
    newStatus: string,
    trackingUrl?: string,
    trackingDetails?: string
  ) => {
    try {
      await orderService.updateOrderStatus(
        orderId,
        newStatus,
        trackingUrl,
        trackingDetails
      );
      await fetchOrders(); // Refresh the list
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to update order status"
      );
    }
  };

  if (loading) {
    return <div>Loading orders...</div>;
  }

  if (error) {
    return <div style={{ color: "red" }}>Error: {error}</div>;
  }

  return (
    <div>
      <h2>Orders ({orders.length})</h2>
      <OrdersTable
        orders={orders}
        onSelectOrder={() => {}} // Not used anymore, modal handles selection
        onStatusUpdate={handleStatusUpdate}
      />
      {/* Modal for order details can be added here */}
    </div>
  );
};
export default OrdersPage;
